import type { TSmiles } from "../reducers/dashboard";

export function getSmilesAction(json: Partial<TSmiles>) {
  return { type: "GET_SMILES", json } as const;
}
